export enum AuthPopupKeys {
    LOGIN = 'login',
    SIGNUP = 'signup',
    REFRESH = 'refresh',
    RESET = 'reset',
}

export interface AuthProps {
    onRedirect: (popupKey: AuthPopupKeys) => void;
    onClose: () => void;
    isVisible: boolean;
}

export interface ResponseContent {
    title: string;
    message: string;
}

export interface AuthResponseProps extends Omit<AuthProps, 'isVisible'> {
    responseContent: ResponseContent;
    onClick?: () => void;
    isSuccess: boolean;
}
